import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import useStyles from './style';
import { chatRedirect } from '../../utils';

const TopHeaderViewer = (props) => {
  const { data, formData, blockState, isUpdated, listPages } = props;
  const { chartData, chartUniqueId } = data || {};
  const classes = useStyles();

  return (
    <React.Fragment>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {chartData?.topBar?.enable && (
          <div className={classes.container}>
            <div className={classes.headerRow}>
              <div className={classes.leftSection}>
                <div className={classes.backButton} onClick={() => { chatRedirect(props.history, props.match.params.appid, listPages) }}>
                  <img src={'/media/svg/previousIconObligations.svg'} alt="back" />
                </div>
                <Typography className={classes.title}>
                  {isUpdated ? chartData?.topBar?.label : chartData?.topBar?.create}
                </Typography>
              </div>
              {
                isUpdated && (
                  <div>
                    <Chip
                      label={blockState["status"]}
                      variant="outlined"
                      classes={{ outlined: classes.customChip }}
                    />
                  </div>
                )
              }
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default TopHeaderViewer;
